/** A product-name hint is never a conversion contract. Always require human confirmation. */
export function caseContentSuggestion(productName: string): number | null {
  const name = productName.normalize("NFKC");
  // Only recognize a single mass × pack-count expression. Bare numbers and
  // nested multipacks (e.g. 12×24) do not establish which level is a case.
  const expressions = [...name.matchAll(/\b\d+(?:[.,]\d+)?\s*(?:kg|gr|g)\s*[x×*]\s*(\d+)\s*(?:adet|kutu|silindir)?/giu)];
  if (expressions.length !== 1) return null;
  const count = Number(expressions[0]?.[1]);
  const tail = name.slice((expressions[0]?.index ?? 0) + (expressions[0]?.[0].length ?? 0));
  if (/^\s*(?:[x×*]\s*\d|[.,]\d)/u.test(tail)) return null;
  const prefix = name.slice(0, expressions[0]?.index ?? 0);
  if (/\d\s*[x×*]\s*$/u.test(prefix)) return null;
  return Number.isSafeInteger(count) && count > 0 && count <= 1_000_000 ? count : null;
}
